import { render, staticRenderFns } from "./new.vue?vue&type=template&id=73e3114c&"
import script from "./new.vue?vue&type=script&lang=ts&"
export * from "./new.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports